import { DEFAULT_MOTISIG_BASE_URL } from '../constants/defaultBaseUrl';

function trimTrailingSlash(value: string): string {
  return value.replace(/\/$/, '');
}

export function resolveClientBaseUrl(explicit?: string): string {
  const fromArg = typeof explicit === 'string' ? explicit.trim() : '';
  if (fromArg !== '') return trimTrailingSlash(fromArg);
  return trimTrailingSlash(DEFAULT_MOTISIG_BASE_URL);
}
